import React, { useState, useEffect,useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom"; 
import Modal from "react-modal";
import axios from "axios";
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { useCart } from "../Cart/CartContext";
import { toast } from "react-toastify";
import profile from '../../assets/svgs/profile.png';
import BigShowCompleteCard from "../Card/BigShowCompleteCard";
import "../GridViewSellTrade/sale-modal.scss";
//import "../GridViewSellTrade/SaleModals.css";
const SaleModals = ({
  SellerShowName,
  SellerInfo,
  SellerId,
  BuyerId,
  selectedCard,
  onSale,
  liveCsrfToken,
  triggerLogin,
   isOpen,
   onClose
}) => {

 
  const { cart, addItem, removeItem } = useCart();
  
  const location = useLocation();
  const navigate = useNavigate();

  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.CardGrid[key][currentLang]; // Adjust the path according to your JSON structure

  
  const [giving, setGiving] = useState([]);
  const [receiving, setReceiving] = useState([]);
  const [thisUserCards, setThisUserCards] = useState([]);
  const [listingUserCards, setListingUserCards] = useState([]);
  const [showThisUserCards, setShowThisUserCards] = useState(true);
  const [comment, setComment] = useState("");
  const [isAnOffer, setIsAnOffer] = useState(false);
  const [price, setPrice] = useState(selectedCard.Price);
  const [total, setTotal] = useState(0);

  const [isBestOfferVisible, setIsBestOfferVisible] = useState(false);
  const [bestOfferAmount, setBestOfferAmount] = useState("");
  const [bestOfferSaved, setBestOfferSaved] = useState(false);
  const initialWidth = typeof window !== "undefined" && window.innerWidth <= 768 ? "30rem" : "40rem";
const initialHeight = typeof window !== "undefined" && window.innerWidth <= 768 ? "57rem" : "40rem";
const initialMarginTop  = typeof window !== "undefined" && window.innerWidth <= 768 ? "1rem" : "10rem";
const [modalSize, setModalSize] = useState({ width: initialWidth, height: initialHeight,marginTop:initialMarginTop });
  //const [watchListId,  setWatchListId] = useState(AlreadySaved)
  
  useEffect(() => {
    const updateSize = () => {
      const isMobile = window.innerWidth <= 768;
      setModalSize({
        width: isMobile ? "100%" : "45rem",
        height: isMobile ? "100%" : "45rem",
        marginTop:isMobile?"1rem" : "10rem",
      });
    };
  
    updateSize(); // Set initial size
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  function resetBestOffer() {
    setIsBestOfferVisible(false);
    setBestOfferAmount("");
    setBestOfferSaved(false);
    setIsAnOffer(false);
    setPrice(selectedCard.Price);
  }

  const cancelXIcon = () => {
    return (
      <span onClick={() => resetBestOffer()} style={{marginBottom:'2vh'}}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="#000"
          version="1.1"
          viewBox="0 0 128 128"
          xmlSpace="preserve"
        >
          <g>
            <path
              fill="#0066FFED"
              d="M64 0C28.656 0 0 28.656 0 64s28.656 64 64 64 64-28.656 64-64S99.344 0 64 0zm0 120C33.125 120 8 94.875 8 64S33.125 8 64 8s56 25.125 56 56-25.125 56-56 56z"
            ></path>
            <path
              fill="#F44336"
              d="M75.313 64l16.969-16.969c3.125-3.125 3.125-8.195 0-11.313-3.117-3.125-8.188-3.125-11.313 0L64 52.688 47.031 35.719c-3.125-3.125-8.195-3.125-11.313 0-3.125 3.117-3.125 8.188 0 11.313L52.688 64 35.719 80.969c-3.125 3.125-3.125 8.195 0 11.313 3.117 3.125 8.188 3.125 11.313 0L64 75.313l16.969 16.969c3.125 3.125 8.195 3.125 11.313 0 3.125-3.117 3.125-8.188 0-11.313L75.313 64z"
            ></path>
          </g>
        </svg>
      </span>
    );
  };

  const disketteSaveIcon = (saved) => {
    const DisketteSaveBlue = () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        fill="#0066FFED"
        stroke="#0066FFED"
        version="1.1"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g>
          <path d="M506.513 98.709L413.291 5.486A18.73 18.73 0 00400.047 0H385.77a6.245 6.245 0 00-6.244 6.244v151.114c0 10.345-8.387 18.732-18.732 18.732H151.196c-10.345 0-18.732-8.387-18.732-18.732V6.244A6.245 6.245 0 00126.22 0H18.732C8.387 0 0 8.387 0 18.732v474.537C0 503.613 8.387 512 18.732 512h474.537c10.345 0 18.732-8.387 18.732-18.732V111.954a18.732 18.732 0 00-5.488-13.245zM400.554 410.226c0 10.345-8.387 18.732-18.732 18.732H130.178c-10.345 0-18.732-8.387-18.732-18.732V263.094c0-10.345 8.387-18.732 18.732-18.732h251.644c10.345 0 18.732 8.387 18.732 18.732v147.132z"></path>
          <path d="M176.172 126.138h159.647a6.244 6.244 0 006.244-6.244V6.244A6.245 6.245 0 00335.819 0H176.172a6.245 6.245 0 00-6.244 6.244v113.65a6.245 6.245 0 006.244 6.244zm99.174-79.868c0-10.345 8.387-18.732 18.732-18.732s18.732 8.387 18.732 18.732v33.598c0 10.345-8.387 18.732-18.732 18.732s-18.732-8.387-18.732-18.732V46.27zM318.413 317.93H193.586c-10.345 0-18.732 8.387-18.732 18.732s8.387 18.732 18.732 18.732h124.828c10.345 0 18.73-8.387 18.73-18.732s-8.386-18.732-18.731-18.732z"></path>
        </g>
      </svg>
    );
    const DisketteSaveGrey = () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        fill="#a1a1a1"
        stroke="#a1a1a1"
        version="1.1"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g>
          <path d="M506.513 98.709L413.291 5.486A18.73 18.73 0 00400.047 0H385.77a6.245 6.245 0 00-6.244 6.244v151.114c0 10.345-8.387 18.732-18.732 18.732H151.196c-10.345 0-18.732-8.387-18.732-18.732V6.244A6.245 6.245 0 00126.22 0H18.732C8.387 0 0 8.387 0 18.732v474.537C0 503.613 8.387 512 18.732 512h474.537c10.345 0 18.732-8.387 18.732-18.732V111.954a18.732 18.732 0 00-5.488-13.245zM400.554 410.226c0 10.345-8.387 18.732-18.732 18.732H130.178c-10.345 0-18.732-8.387-18.732-18.732V263.094c0-10.345 8.387-18.732 18.732-18.732h251.644c10.345 0 18.732 8.387 18.732 18.732v147.132z"></path>
          <path d="M176.172 126.138h159.647a6.244 6.244 0 006.244-6.244V6.244A6.245 6.245 0 00335.819 0H176.172a6.245 6.245 0 00-6.244 6.244v113.65a6.245 6.245 0 006.244 6.244zm99.174-79.868c0-10.345 8.387-18.732 18.732-18.732s18.732 8.387 18.732 18.732v33.598c0 10.345-8.387 18.732-18.732 18.732s-18.732-8.387-18.732-18.732V46.27zM318.413 317.93H193.586c-10.345 0-18.732 8.387-18.732 18.732s8.387 18.732 18.732 18.732h124.828c10.345 0 18.73-8.387 18.73-18.732s-8.386-18.732-18.731-18.732z"></path>
        </g>
      </svg>
    );

    return saved ? (
      <button onClick={submitBestOffer}>
        <DisketteSaveBlue />
      </button>
    ) : (
      null
    );
  };


  function PriceOfferCell({
  price,                 // number | string (e.g. 110 or "110")
  onSubmit,              // (newPriceNumber) => void | Promise<void>
  onCancel,              // optional callback when user cancels
  t = (s) => s,          // i18n function
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(price ?? 0);
  const [dirty, setDirty] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => { setValue(price ?? 0); setDirty(false); }, [price]);
  useEffect(() => { if (isEditing) inputRef.current?.focus(); }, [isEditing]);

  const openEdit = () => setIsEditing(true);

  const closeEdit = () => {
    setIsEditing(false);
    setValue(price ?? 0);
    setDirty(false);
    onCancel?.();
  };

  const handleChange = (e) => {
    // keep only digits
    const raw = e.target.value.replace(/[^\d]/g, "");
    setValue(raw);
    setDirty(String(raw) !== String(price ?? 0));
  };

  const canSave = dirty && Number(value) > 0;

  const handleSave = async () => {
    if (!canSave) return;
    await onSubmit?.(Number(value));
    setDirty(false);
    setIsEditing(false);
  };

  const handleKey = (e) => {
    if (e.key === "Enter") { e.preventDefault(); handleSave(); }
    if (e.key === "Escape") { e.preventDefault(); closeEdit(); }
  };

  return (
    <div className="offer-cell">
      {!isEditing ? (
        <div className="offer-view">
          <button
            type="button"
            className="offer-button"
            onClick={openEdit}
            aria-label={t("Offer")}
          >
            {t("Offer")}
          </button>

          <span className="price-chip" aria-label={"Current price"}>
            {Number(price) || 0}<span className="currency"> $</span>
          </span>
        </div>
      ) : (
        <div className="offer-edit">
          <div className="flex-h" data-suffix="$">
              <button
            type="button"
            className="icon-btn cancel"
            aria-label={t("Cancel")}
            onClick={closeEdit}
          >
            {/* X icon */}
            <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">
              <path fill="#0071E7" d="M11.41 10l4.3-4.29a1 1 0 10-1.42-1.42L10 8.59 5.71 4.29a1 1 0 10-1.42 1.42L8.59 10l-4.3 4.29a1 1 0 101.42 1.42L10 11.41l4.29 4.3a1 1 0 001.42-1.42z"/>
            </svg>
          </button>
            <input
              ref={inputRef}
              type="text"
              inputMode="numeric"
              pattern="\d*"
              value={value}
              onChange={handleChange}
              onKeyDown={handleKey}
              className="offer-input noMargin"
              aria-label={"Enter your offer"}
            />
            
          {canSave && (
 <button
  type="button"
  className="icon-btn save"
  aria-label={"Save offer"}
  onClick={handleSave}
  disabled={!canSave}
>
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path fill="currentColor" d="M9 16.2l-3.5-3.5a1 1 0 10-1.4 1.4l4.2 4.2a1 1 0 001.4 0l10-10a1 1 0 10-1.4-1.4L9 16.2z"/>
  </svg>
</button>
          )}
          </div>

        

        </div>
      )}
    </div>
  );
}
  // useEffect(() => {
  //   const thisPrice = parseFloat(price);
  //   const shipping = parseFloat(selectedCard.Shipping);
  //   const bestoffer = parseFloat(bestOfferAmount);

  //   if (bestoffer === thisPrice) setBestOfferSaved(true);
  //   else setBestOfferSaved(false);

  //   if (isBestOfferVisible) {
  //     if (!isNaN(bestoffer) && !isNaN(shipping)) {
  //       setTotal(bestoffer + shipping);
  //     } else {
  //       setTotal(0); // Set total to 0 if parsing fails
  //     }
  //   } else {
  //     // Check if the parsed values are valid numbers
  //     if (!isNaN(thisPrice) && !isNaN(shipping)) {
  //       setTotal(thisPrice + shipping);
  //     } else {
  //       setTotal(0); // Set total to 0 if parsing fails
  //     }
  //   }
  // }, [price, bestOfferAmount, isBestOfferVisible]);

  useEffect(() => {
  const p = Number(price) || 0;
  const s = Number(selectedCard.Shipping) || 0;
  setTotal(p + s);
}, [price, selectedCard.Shipping]);



  const showBestOfferInput = () => {
    setIsBestOfferVisible(!isBestOfferVisible);
      // Delay focus slightly to ensure input is mounted
  setTimeout(() => {
    document.getElementById("bestOfferInput")?.focus();
  }, 100);
  };

  const handleBestOfferChange = (event) => {
    const value = event.target.value;
    if (
      value === "" ||
      (!isNaN(value) && value.trim() !== "" && !/^0\d/.test(value))
    )
      setBestOfferAmount(value);
  };

  const submitBestOffer = async () => {
    // Perform any actions with the best offer amount here

    const thisPrice = parseFloat(bestOfferAmount);
    const shipping = parseFloat(selectedCard.Shipping);
    
    if(thisPrice>selectedCard.Price&&selectedCard.Price!==0)
    {
      toast.error(t('theofferishigherthantheprice'))
      return;
    }

    // Check if the parsed values are valid numbers
    if (!isNaN(thisPrice) && !isNaN(shipping)) {
      setTotal(thisPrice + shipping);
    } else {
      setTotal(0); // Set total to 0 if parsing fails
    }

    setPrice(bestOfferAmount);
    setIsAnOffer(true);
    // Reset the state or close the input field if needed
    //setIsBestOfferVisible(false);
    //setBestOfferAmount('');
  };

  const handleCommentChange = async (event) => {
    await setComment(event.target.value);
  };

  useEffect(() => {
    setThisUserCards(selectedCard);
    console.log("bein oui je trigger1", BuyerId);
                     if (!BuyerId) {
      triggerLogin();
      console.log("bein oui je trigger");
    }
  }, []);

    useEffect(() => {
    
    console.log("bein oui je trigger1", BuyerId);
                     if (!BuyerId) {
      triggerLogin();
      console.log("bein oui je trigger");
    }
  }, [isOpen]);

  const closeModal = () => {
    //setIsModalOpen(false);
    setGiving([]);
    setReceiving([]);
    onClose();
  };

  // Function to get the sum of tradeValues for the wanted cards

  const handleAddToCart = () => {
    // Assuming product is an object with the necessary item details
    console.log("selectedCard", selectedCard);
    const item = {
      BestOffer: selectedCard.BestOffer,
      Shipping: selectedCard.Shipping,
      MinorCardShipping: selectedCard.MinorCardShipping,
      MediumCardShipping: selectedCard.MediumCardShipping,
      BigCardShipping: selectedCard.BigCardShipping,
      ListingDisabled: selectedCard.ListingDisabled,
      ConditionCard: selectedCard.ConditionCard,
      Graded: selectedCard.Graded,
      GradeCompany: selectedCard.GradeCompany,
      Grade: selectedCard.Grade,
      ImageFront: selectedCard.ImageFront,
      ImageUserBack: selectedCard.ImageUserBack,
      Image: selectedCard.Image,
      ImageBack: selectedCard.ImageBack,
      userCardId: selectedCard.userCardId||selectedCard.id,
      SellcardsID: selectedCard.ID,
      SellerId: SellerId,
      sellerName: SellerShowName,
      title: selectedCard.SearchTitle,
      Price: price,
      InitialPrice:selectedCard.Price,
      image: selectedCard.ImageFront,

    };
    console.log("selectedCard item", item);
    addItem(item);
  };

  // Check if the item is already in the cart
  const isInCart = () => {
    return cart.some(
      (cartItem) =>
        parseInt(cartItem.userCardId) === parseInt(selectedCard.userCardId)
    );
  };

  const handleRemoveFromCart = () => {
    removeItem(selectedCard.userCardId);
  };

  const handleSendRequest = () => {
    sendOffer(BuyerId, SellerId, isAnOffer, selectedCard.userCardId, price);
    console.log("Transaction as been sent");
    closeModal();
  };

  function sendOffer(BuyerId, SellerId, isAnOffer, userCardId, price) {
    const givingData = 0;
    const receivingData = 0;

    console.log("BuyerId", BuyerId, giving, SellerId, receiving);
    // Log the data

    if (userCardId !== null > 0 && userCardId !== SellerId) {
      submitOffer(
        BuyerId,
        SellerId,
        isAnOffer,
        userCardId,
        price,
        comment,
        liveCsrfToken
      );
      console.log("Offer Send");
    } else console.log("Trade is not completed.");
  }
  function resetAll() {
    setGiving([]);
    setReceiving([]);
    setComment("");
    console.log("Everything as been reset");
  }

  async function submitOffer(
    BuyerId,
    SellerId,
    isAnOffer,
    userCardId,
    price,
    comments,
    liveCsrfToken
  ) {
    let userCardArray = userCardId;
    if (!Array.isArray(userCardId)) {
      userCardArray = [userCardId];
    }

    console.log("Submitting trade offer for card(s):", userCardId);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/submitOffer`,
        {
          BuyerId: BuyerId,
          SellerId: SellerId,
          isAnOffer: isAnOffer,
          userCardId: userCardArray,
          comments: comments,
          price: price,
          shipping: selectedCard.Shipping,
          userId: BuyerId, // Add userId to the body
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-csrf-token": liveCsrfToken, // Include CSRF token
          },
          withCredentials: true, // Ensure session cookies are sent
        }
      );

      // Handle the response from the server
      console.log("Trade Offer Submitted:", response.data);
      toast.success(t("Offer submitted successfully")); // Show success toast

      // You can perform additional actions based on the response if needed
      resetAll();
    } catch (error) {
      console.error("Error submitting offer:", error);
      toast.error(t("Failed to submit offer")); // Show error toast
    }
  }
  const toggleUserCards = () => {
    setShowThisUserCards(!showThisUserCards);
  };


  function triggerOnClickCard(formData) {
    // Create a sanitized card without Location if user IDs don’t match
    const sanitizedCard =
      parseInt(formData.UserId) !== parseInt(BuyerId)
        ? { ...formData, Location: undefined }
        : formData;

    navigate(`/cards/${sanitizedCard.id}`, {
      state: { card: sanitizedCard, viewAsGrid: false },
    });
  }
const handleOfferSubmit = async (newPrice) => {
  // optional guard: don't allow offers higher than current price
  if (Number(newPrice) > Number(selectedCard.Price) && selectedCard.Price!==0) {
    toast.error(t('theofferishigherthantheprice'));
    return;
  }
  setPrice(newPrice);
  setIsAnOffer(true);
};

// When the user cancels editing in PriceOfferCell
const handleOfferCancel = () => {
  setIsAnOffer(false);
  setPrice(selectedCard.Price); // revert to original
};
  return (
    <>

 <Modal isOpen={isOpen} onRequestClose={closeModal} style={{ overlay: { background: 'rgba(14, 29, 48, 0.1)', zIndex: 1000, }, content: {  width: modalSize.width, height: modalSize.height,margin: "auto", marginTop: modalSize.marginTop, background: "#09121E", inset: '2px', }  }} className={"sale-modal"}>
  <h2 className="sale-modal__title">{t("Complete purchase")}</h2>

  <div className="sale-seller-info">
    <div
      className="seller-profile"
      onClick={() => navigate(`/ViewUserProfil/${SellerInfo.ShowName}`)}
    >
      <img
        src={SellerInfo.ProfilPicture || profile}
        alt="Seller Profile"
        className="profile-picture"
      />
      <div className="seller-details">
        <span className="seller-name">{SellerInfo.ShowName}</span>
        <span className="seller-rating">
          ({SellerInfo.NumberOfTransactions}) {SellerInfo.AverageX5}%
        </span>
        <span className="seller-location">
          <img
            src={`https://flagcdn.com/w40/${SellerInfo.CountryCode.toLowerCase()}.png`}
            className="country-flag"
            alt="flag"
          />
          {SellerInfo.City}, {SellerInfo.Country}
        </span>
      </div>
    </div>
  </div>

  <div className="sale-modal-content">
    <div className="sale-modal-left">
      <BigShowCompleteCard
        formData={selectedCard}
        showPrice={true}
        regularSize={true}
      />
    </div>

    <div className="sale-modal-right">
      <div className="sale-price-table">
        <table>
          <tbody>
            <tr className="sale-price-container">
              <td>{t("Price")}</td>
              <td>
                {/* {isBestOfferVisible ? (
                  <div className="offer-container">
                    <input
                      type="text"
                      id="bestOfferInput"
                      value={bestOfferAmount}
                      onChange={handleBestOfferChange}
                      onKeyDown={(e) => e.key === "Enter" && submitBestOffer()}
                      className="offer-input"
                    />
                    {cancelXIcon()}
                    {disketteSaveIcon(!bestOfferSaved)}
                  </div>
                ) : (<>{!isBestOfferVisible && (
                  <button
                    onClick={showBestOfferInput}
                    className="offer-button"
                  >
                    {t("Offer")}
                  </button>
                )}
                  {selectedCard.Price}$</>
                )} */}
            <PriceOfferCell
  price={price}
  onSubmit={handleOfferSubmit}
  onCancel={handleOfferCancel}
  t={t}
/>
              
              </td>
            
            </tr>

            <tr className="sale-shipping-container">
              <td>{t("Shipping")}</td>
              <td colSpan="3" className="sale-shipping">
                {selectedCard.Shipping}$
              </td>
            </tr>

            <tr className="sale-total-row">
              <td>{t("Total")}</td>
              <td colSpan="3">{total}$</td>
            </tr>
          </tbody>
        </table>
      </div>

      <label className="sale-comment-label">{t("Comment")}</label>
      <textarea
        value={comment}
        onChange={handleCommentChange}
        maxLength={398}
        rows={4}
        className="sale-comment-box"
        placeholder={t("Write a comment for the seller")}
      />

      <div className="sale-button-group">
        <button
          onClick={handleSendRequest}
          className="sale-btn-confirm"
          hidden={selectedCard.UserId === BuyerId}
        >
          {t("Confirm Purchase")}
        </button>

        {isInCart() ? (
          <button
            onClick={handleRemoveFromCart}
            className="sale-btn-remove-cart"
            hidden={selectedCard.UserId === BuyerId}
          >
            {t("Remove from Cart")}
          </button>
        ) : (
          <button
            onClick={handleAddToCart}
            className="sale-btn-add-cart"
            hidden={selectedCard.UserId === BuyerId}
          >
            {t("Add to Cart")}
          </button>
        )}
      </div>
    </div>
  </div>

  <div className="sale-modal__footer">
    <button onClick={closeModal} className="btn-baseBlue sale-modal__close">
      {t("Close")}
    </button>
  </div>
</Modal>
     
    </>
  );
};

export default SaleModals;
